module.exports = __webpack_public_path__ + "static/Meda_Sermuksne-85f93eb70eeedfa90e854e7b559e22b0.png";